import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import {
  selectedWorkCompanyState,
  selectedWorkPjTagState,
  selectedWorkTopicTagsState,
} from "store/document/workDocument";
import { NoneOrderTagDetailResponse } from "apis/data-contracts";

const useWorkDocumentTags = () => {
  // 일반 태그
  const [companyTag] = useRecoilState(selectedWorkCompanyState);
  const [pjTag] = useRecoilState(selectedWorkPjTagState);
  const [topicTags] = useRecoilState(selectedWorkTopicTagsState);

  function getTagUuids() {
    const tagUuids = [];
    if (pjTag?.tagUuid) tagUuids.push(pjTag?.tagUuid);
    tagUuids.push(...topicTags.map((tag) => tag.tagUuid));

    return tagUuids;
  }

  // 회사 & PJ 태그
  const [companyAndPjTags, setCompanyAndPjTags] = useState<
    NoneOrderTagDetailResponse[]
  >([]);

  useEffect(() => {
    const newCompanyAndPjTags: NoneOrderTagDetailResponse[] = [];

    if (companyTag) {
      newCompanyAndPjTags.push({
        tagUuid: companyTag.uuid,
        tagName: companyTag.name,
      });
    }

    if (pjTag) {
      newCompanyAndPjTags.push(pjTag);
    }

    setCompanyAndPjTags(newCompanyAndPjTags);
  }, [companyTag, pjTag]);

  return {
    companyTag,
    pjTag,
    topicTags,

    companyAndPjTags,

    getTagUuids,
  };
};

export default useWorkDocumentTags;
